import { IntervalTypes } from 'common/components/entities/WebinarRegistrationDate/WebinarRegistrationDate'
import { EntityTypeEnum } from 'common/enums/entityTypeEnum'
import WebinarRegistrationDateInterface from 'common/types/entities/WebinarRegistrationDateInterface'
import { generateBaseEntity } from 'src/shared/entities/utils/generate-base-entity'
import { MasterBlockIdType } from 'src/shared/schemas/master-block-id.schema'

export function createWebinarRegistrationDate(
  parentId: string,
  masterBlockId?: MasterBlockIdType,
): WebinarRegistrationDateInterface {
  return {
    ...generateBaseEntity(
      EntityTypeEnum.WebinarRegistrationDate,
      parentId,
      masterBlockId,
    ),
    timeFormat: 24,
    spaceBetween: 20,
    scheduledHours: [],
    interval: IntervalTypes.hour,
  }
}
